import ImagesSVG from "./ImagesSVG.component";

export default ImagesSVG